module.exports = __webpack_public_path__ + "static/img/logo_trans.c0d6dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_trans.png
// module id = a+8q
// module chunks = 0